import { MultiSelector } from '../../MultiSelector';
import { type CSSProperties, type FC} from 'react';
import {type NestedOrganization, type NestedPermission } from 'types';

type TypeSelectorProps = {
  availableFileTypes: NestedPermission[],
  selectedFileTypes: string[],
  setSelectedFileTypes: React.Dispatch<React.SetStateAction<string[]>>,
  style?: CSSProperties,
};

const getPermissionOptions = (types: NestedPermission[]) => {
  const typeOption = types.map((type) => {
    return {display: type.name,
      id: type.code,
    };
  });

  return typeOption;
};

export const getAccountsIds = (data: NestedOrganization | null) => {
  return data?.funds.flatMap((fund) => fund.accounts.map((acc) => acc.accountId)) ?? [];
};

const TypeSelector: FC<TypeSelectorProps> = ({
  availableFileTypes, selectedFileTypes, setSelectedFileTypes, style}: TypeSelectorProps) => {
  const checkType = (typeIds: string[]) => {
    setSelectedFileTypes(typeIds);
  };

  return (
    <MultiSelector
      dataSelectionValue='download-files-select-filters-filetype-multiselector'
      description='Select documents types'
      disabled={!availableFileTypes.length}
      onOption={checkType}
      optionList={getPermissionOptions(availableFileTypes)}
      placeholder='file type'
      selectedIds={selectedFileTypes}
      style={style || { width: '250px' }}
      title='Document type'
    />
  );
};

export { TypeSelector };
